import { useTranslation } from '@mukil/i18n';
import {
  Avatar,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@jumpstone/ui-react';
import { useSession } from '../../data/use_session';
import { navigate } from '../../lib/router';
import { LocaleSwitcher } from '../common/locale_switcher';
import { SignOutMenuItem } from './sign_out_menu_item';

/** Avatar menu: profile shortcut, role preview switch and sign-out. */
export function AccountMenu(): React.JSX.Element {
  const { t } = useTranslation('wp');
  const { session, is_admin, toggle_role } = useSession();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="wp-avatar-button rounded-full"
          aria-label={t('account.open')}
        >
          <Avatar name={session.name} colorVariant={session.tint} size="sm" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[200px]">
        <DropdownMenuLabel>{session.name}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onSelect={() => {
            navigate({
              module: 'employees',
              view: 'profile',
              employee_id: null,
              tab: 'job',
            });
          }}
        >
          {t('account.profile')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => {
            toggle_role();
            navigate(is_admin ? { module: 'my_pay' } : { module: 'dashboard' });
          }}
        >
          {is_admin
            ? t('account.switch_to_employee')
            : t('account.switch_to_admin')}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {/* Was a bare `<DropdownMenuItem>` with no handler — see
            `SignOutMenuItem`'s docblock. */}
        <SignOutMenuItem />
        <DropdownMenuSeparator />
        {/* Language switcher — stop propagation so clicks don't close the menu */}
        <div
          className="px-2 py-1.5"
          onPointerDown={(e) => {
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <LocaleSwitcher />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
